import{useState as o,useCallback as t}from"react";const r=()=>{const[r,e]=o(!1),g=t((()=>e(!r)),[r]);return{isToggled:r,toggle:g}};export{r as useToggle};
//# sourceMappingURL=useToggle.js.map
